import RobotoBlack from "./Roboto-Black.ttf";
import RobotoBlackItalic from "./Roboto-BlackItalic.ttf";
import RobotoBold from "./Roboto-Bold.ttf";
import RobotoBoldItalic from "./Roboto-BoldItalic.ttf";
import RobotoLight from "./Roboto-Light.ttf";
import RobotoLightItalic from "./Roboto-LightItalic.ttf";
import RobotoRegular from "./Roboto-Regular.ttf";
import RobotoThin from "./Roboto-Thin.ttf";
import RobotoThinItalic from "./Roboto-ThinItalic.ttf";

export default `
  @font-face {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 100;
    src: url(${RobotoThin}) format("truetype");
  }

  @font-face {
    font-family: "Roboto";
    font-style: italic;
    font-weight: 100;
    src: url(${RobotoThinItalic}) format("truetype");
  }

  @font-face {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 300;
    src: url(${RobotoLight}) format("truetype");
  }

  @font-face {
    font-family: "Roboto";
    font-style: italic;
    font-weight: 300;
    src: url(${RobotoLightItalic}) format("truetype");
  }

  @font-face {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    src: url(${RobotoRegular}) format("truetype");
  }

  @font-face {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    src: url(${RobotoBold}) format("truetype");
  }

  @font-face {
    font-family: "Roboto";
    font-style: italic;
    font-weight: 700;
    src: url(${RobotoBoldItalic}) format("truetype");
  }

  @font-face {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 900;
    src: url(${RobotoBlack}) format("truetype");
  }

  @font-face {
    font-family: "Roboto";
    font-style: italic;
    font-weight: 900;
    src: url(${RobotoBlackItalic}) format("truetype");
  }
`;
